import PdfPNG from 'src/assets/pdf.png';

const PDFPreview = ({ onClick, isSinglePdf }) => {
  console.log('singlePDF:', isSinglePdf);
  return (
    <div
      className={`p-5 md:p-12 h-full flex flex-col items-center justify-center border border-gray-300 rounded-lg cursor-pointer hover:shadow-md transition-shadow duration-300 ease-in-out ${
        isSinglePdf ? 'max-w-[200px] mr-auto' : ''
      }`}
      onClick={onClick}
    >
      <img src={PdfPNG} alt="PDF Icon" className="w-12 h-12" />
      <p className=" mt-2 text-sm text-gray-600 text-center">Click to view the PDF file</p>
    </div>
  );
};

export default PDFPreview;
